import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Send } from "lucide-react";

const MAX_CHARS = 1200;

export const ChatComposer = ({ loading, quota, onSend }) => {
  const [input, setInput] = useState("");
  const exhausted = quota?.remaining === 0;

  const submit = () => {
    const text = input.trim();
    if (!text) return;
    setInput("");
    onSend(text);
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      submit();
    }
  };

  return (
    <div className="p-3 border-t border-[rgba(4,22,46,0.14)] bg-white">
      <div className="flex items-end gap-2">
        <textarea
          data-testid="chat-input"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={onKeyDown}
          rows={1}
          maxLength={MAX_CHARS}
          disabled={exhausted}
          placeholder={exhausted ? "Daily message allowance reached" : "Ask about our process safety services..."}
          className="flex-1 resize-none max-h-28 rounded-[2px] bg-white border border-[rgba(4,22,46,0.14)] px-3 py-2.5 font-body text-sm text-[#04162E] placeholder:text-[#8FA0B3] focus:outline-none focus:border-[#0E8A57] focus:ring-1 focus:ring-[#0E8A57]"
        />
        <button
          data-testid="chat-send"
          onClick={submit}
          disabled={loading || !input.trim() || exhausted}
          className="grid place-items-center h-10 w-10 shrink-0 rounded-[2px] bg-[#0E8A57] hover:bg-[#0F9A62] text-white disabled:opacity-40 transition-colors"
          aria-label="Send message"
        >
          <Send className="h-4 w-4" />
        </button>
      </div>
      <p className="mt-1.5 text-center font-body text-[10px] text-[#8FA0B3]">
        {quota && (
          <span data-testid="chat-quota" className={quota.remaining <= 5 ? "text-[#B5842A]" : ""}>
            {quota.remaining} of {quota.limit} messages left today ·{" "}
          </span>
        )}
        AI can make mistakes — verify critical safety information. Chats are stored per our{" "}
        <Link to="/privacy" className="text-[#5C6C80] hover:text-[#0B6B44] underline">
          Privacy Policy
        </Link>
        .
      </p>
    </div>
  );
};
